import { CaptainLineupsAndScoresPermissions } from '@/entities/season-division/SeasonDivisionPool';

export enum PermissionRole {
	SUPER_ADMIN = 'SUPER_ADMIN',
	TEAM_LEAGUES_GLOBAL_MANAGER = 'TEAM_LEAGUES_GLOBAL_MANAGER',
	COMMISSIONER = 'COMMISSIONER',
	PRIMARY_MANAGER = 'PRIMARY_MANAGER',
	TEAM_LEAGUE_MANAGER = 'TEAM_LEAGUE_MANAGER',
	CAN_MANAGE_GAMEDAYS = 'CAN_MANAGE_GAME_DAYS',
	TEAM_CAPTAIN = 'TEAM_CAPTAIN',
	NOT_AUTHORIZED = 'NOT_AUTHORIZED'
}

export const LIMITED_ACCESS = [PermissionRole.TEAM_CAPTAIN, PermissionRole.NOT_AUTHORIZED];

export const UNLIMITED_ACCESS = [
	PermissionRole.SUPER_ADMIN,
	PermissionRole.TEAM_LEAGUES_GLOBAL_MANAGER,
	PermissionRole.COMMISSIONER,
	PermissionRole.PRIMARY_MANAGER
];

export const SCORES_PERMISSIONS = [
	CaptainLineupsAndScoresPermissions.FULL_CONTROL_CAPTAIN_PERMISSION,
	CaptainLineupsAndScoresPermissions.SCORES_ONLY_CAPTAIN_PERMISSION
];

export const LINEUP_PERMISSIONS = [
	CaptainLineupsAndScoresPermissions.FULL_CONTROL_CAPTAIN_PERMISSION,
	CaptainLineupsAndScoresPermissions.LINEUP_ONLY_CAPTAIN_PERMISSION
];
